// Application Constants

// Re-export from permissions.js for backward compatibility
export {
  STORAGE_KEYS,
  USER_TYPES,
  ACTIONS,
  MODULES
} from '../permissions';

// API Base URLs based on environment
export const BASE_URLS = {
  local: 'http://localhost:9000/api',
  dev: 'https://crowdvox-platform-dev-api.aiolos.cloud/api',
  uat: 'http://localhost:9000/api',
  prod: 'https://platform-api.crowdvox.ai/api',
  stage: 'https://crowdvox-platform-stage-api.aiolos.cloud/api',
};

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
};

// User Type options for dropdown (used in User Management forms)
export const USER_TYPE_OPTIONS = [
  { label: 'Super Admin', value: 'super-admin' },
  { label: 'Admin', value: 'admin' },
  { label: 'Organization Admin', value: 'organization-admin' },
  { label: 'Organization User', value: 'org-user' },
];

// Password validation regex
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export default {
  BASE_URLS,
  HTTP_STATUS,
  USER_TYPE_OPTIONS,
  PASSWORD_REGEX,
};
